import React, { useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'animate.css';

const GPTAgentFrontend = () => {
    const [prompt, setPrompt] = useState('');
    const [result, setResult] = useState(null);
    const [tireListings, setTireListings] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [tokenUsage, setTokenUsage] = useState(null);
    const [searchHistory, setSearchHistory] = useState([]);
    const promptRef = useRef(null);

    // API call to backend
    const searchGPTAgent = async (searchPrompt) => {
        setLoading(true);
        setError('');
        setResult(null);
        setTokenUsage(null);
        setTireListings(null);

        const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

        try {
            // Make API call to backend
            const response = await fetch(`${mainUrl}/api/gpt-search-tool`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    prompt: searchPrompt
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.error || 'Search failed');
            }

            setResult(data.results || '');
            setTireListings(data.results || '');
            setTokenUsage(data.totalTokens || {});

            // Add to search history
            setSearchHistory(prev => [{
                prompt: searchPrompt,
                timestamp: data.timestamp || new Date().toISOString(),
                query: data.query || searchPrompt,
                tokensUsed: data.totalTokens?.total_tokens || 0,
                inputTokens: data.totalTokens?.prompt_tokens || 0,
                outputTokens: data.totalTokens?.completion_tokens || 0
            }, ...prev.slice(0, 4)]); // Keep only last 5 searches

        } catch (err) {
            setError(err.message || 'Failed to search. Please try again.');
            console.error('Search error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!prompt.trim()) {
            setError('Please enter a search prompt');
            return;
        }

        await searchGPTAgent(prompt.trim());
    };

    const handleClearResults = () => {
        setResult(null);
        setTokenUsage(null);
        setError('');
    };

    const formatTimestamp = (timestamp) => {
        return new Date(timestamp).toLocaleString();
    };

    const calculateCost = (tokens) => {
        // Approximate cost calculation (adjust rates as needed)
        const inputCost = (tokens.input_tokens / 1000) * 0.00150; // $0.0015 per 1K input tokens
        const outputCost = (tokens.output_tokens / 1000) * 0.00200; // $0.002 per 1K output tokens
        return (inputCost + outputCost).toFixed(4);
    };

    const extractKeyInfo = (text) => {
        const lines = text.split('\n').filter(line => line.trim());
        const keyInfo = {
            title: '',
            summary: '',
            features: [],
            specifications: {}
        };

        // Extract title (first meaningful line)
        keyInfo.title = lines[0] || 'Search Result';

        // Extract summary (first paragraph)
        const firstParagraphEnd = text.indexOf('\n\n');
        keyInfo.summary = firstParagraphEnd > 0 ? text.substring(0, firstParagraphEnd) : text.substring(0, 200) + '...';

        // Extract features
        const featuresMatch = text.match(/\*\*Key Features:\*\*(.*?)(?=\*\*|$)/s);
        if (featuresMatch) {
            keyInfo.features = featuresMatch[1]
                .split(/- \*\*/)
                .filter(f => f.trim())
                .map(f => f.replace(/\*\*/g, '').trim())
                .slice(0, 5);
        }

        return keyInfo;
    };

    console.log('result', result);
    console.log('tokenUsage', tokenUsage);

    const keyInfo = result ? extractKeyInfo(result) : null;

    return (
        <div className="container-fluid py-4" style={{ maxWidth: '1200px', margin: '0 auto' }}>
            {/* Header */}
            <div
                className="card shadow-lg mb-4 "
                style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none'
                }}
            >
                <div className="card-body p-4">
                    <div className="d-flex align-items-center">
                        <i className="fa fa-brain fa-3x me-3"></i>
                        <div>
                            <h6 className="card-title mb-1 fw-bold">GPT Agent Search</h6>
                            {/* <p className="card-subtitle mb-0 opacity-75">
                                Intelligent search with comprehensive token tracking
                            </p> */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Search Form */}
            <div className="card shadow mb-4 ">
                <div className="card-body p-4">
                    <div className="row g-3">
                        <div className="col-md-9">
                            <div className="form-floating">
                                <textarea
                                    ref={promptRef}
                                    className="form-control"
                                    id="searchPrompt"
                                    style={{ height: '120px' }}
                                    placeholder="Ask anything about products, specifications, or any topic..."
                                    value={prompt}
                                    onChange={(e) => setPrompt(e.target.value)}
                                    disabled={loading}
                                />
                                <label htmlFor="searchPrompt">Enter your search prompt</label>
                            </div>
                            {/* <small className="text-muted mt-1">
                Characters: {prompt.length} | Press Ctrl+Enter to search quickly
              </small> */}
                        </div>
                        <div className="col-md-3">
                            <div className="d-flex flex-column gap-2 h-100">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg d-flex align-items-center justify-content-center flex-fill"
                                    onClick={handleSubmit}
                                    disabled={loading || !prompt.trim()}
                                    style={{ minHeight: '56px' }}
                                >
                                    {loading ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            Searching...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search me-2"></i>
                                            Search
                                        </>
                                    )}
                                </button>
                                {result && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={handleClearResults}
                                        disabled={loading}
                                    >
                                        <i className="fa fa-trash me-1"></i>
                                        Clear
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Error Display */}
            {error && (
                <div className="alert alert-danger animate__animated animate__shakeX" role="alert">
                    <i className="fa fa-exclamation-triangle me-2"></i>
                    {error}
                </div>
            )}

            {/* Search History */}
            {searchHistory.length > 0 && (
                <div className="card shadow-sm mb-4 animate__animated animate__fadeIn">
                    <div className="card-body">
                        <h6 className="card-title mb-3">
                            <i className="fa fa-history me-2"></i>
                            Recent Searches
                        </h6>
                        <div className="d-flex flex-wrap gap-2">
                            {searchHistory.map((search, index) => (
                                <span
                                    key={index}
                                    className="badge bg-light text-dark border cursor-pointer p-2"
                                    onClick={() => setPrompt(search.prompt)}
                                    style={{ cursor: 'pointer', fontSize: '0.8rem' }}
                                    title="Click to reuse this search"
                                >
                                    "{search.prompt.slice(0, 30)}{search.prompt.length > 30 ? '...' : ''}"
                                    <small className="text-muted ms-1">({search.tokensUsed} tokens)</small>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Token Usage Summary */}
            {tokenUsage && (
                <div className="card shadow mb-4 ">
                    <div className="card-body">
                        <h6 className="card-title mb-3">
                            <i className="fa fa-chart-bar me-2"></i>
                            Token Usage Analytics
                        </h6>
                        <div className="row text-center">
                            <div className="col-6 col-md-3 mb-3">
                                <div className="d-flex align-items-center justify-content-center">
                                    <i className="fa fa-sign-in-alt text-primary fa-2x me-3"></i>
                                    <div>
                                        <h4 className="mb-0 text-primary">{tokenUsage.input_tokens || 0}</h4>
                                        <small className="text-muted">Input Tokens</small>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3 mb-3">
                                <div className="d-flex align-items-center justify-content-center">
                                    <i className="fa fa-sign-out-alt text-success fa-2x me-3"></i>
                                    <div>
                                        <h4 className="mb-0 text-success">{tokenUsage.output_tokens || 0}</h4>
                                        <small className="text-muted">Output Tokens</small>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-3 mb-3">
                                <div className="d-flex align-items-center justify-content-center">
                                    <i className="fa fa-calculator text-warning fa-2x me-3"></i>
                                    <div>
                                        <h4 className="mb-0 text-warning">{tokenUsage.total_tokens?.toLocaleString() || 0}</h4>
                                        <small className="text-muted">Total Tokens</small>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-6 col-md-3 mb-3">
                <div className="d-flex align-items-center justify-content-center">
                  <i className="fa fa-dollar-sign text-info fa-2x me-3"></i>
                  <div>
                    <h4 className="mb-0 text-info">${calculateCost(tokenUsage)}</h4>
                    <small className="text-muted">Est. Cost</small>
                  </div>
                </div>
              </div> */}
                        </div>

                        {/* Token Usage Progress Bars */}
                        {/* <div className="mt-3">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label small">Input vs Output Ratio</label>
                  <div className="progress mb-2">
                    <div 
                      className="progress-bar bg-primary" 
                      style={{ width: `${(tokenUsage.input_tokens / tokenUsage.total_tokens) * 100}%` }}
                      title={`Input: ${tokenUsage.input_tokens} tokens`}
                    >
                      Input ({((tokenUsage.input_tokens / tokenUsage.total_tokens) * 100).toFixed(1)}%)
                    </div>
                    <div 
                      className="progress-bar bg-success" 
                      style={{ width: `${(tokenUsage.output_tokens / tokenUsage.total_tokens) * 100}%` }}
                      title={`Output: ${tokenUsage.output_tokens} tokens`}
                    >
                      Output ({((tokenUsage.output_tokens / tokenUsage.total_tokens) * 100).toFixed(1)}%)
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="form-label small">Efficiency Score</label>
                  <div className="progress mb-2">
                    <div 
                      className={`progress-bar ${tokenUsage.output_tokens > tokenUsage.input_tokens ? 'bg-success' : 'bg-warning'}`}
                      style={{ width: `${Math.min((tokenUsage.output_tokens / tokenUsage.input_tokens) * 50, 100)}%` }}
                    >
                      {(tokenUsage.output_tokens / tokenUsage.input_tokens).toFixed(2)}x output ratio
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
                    </div>
                </div>
            )}

            {/* Main Result Display */}
            {
                result && keyInfo && (
                    <div className="card shadow-sm mb-4 ">
                        <div className="card-header bg-gradient" style={{ background: 'linear-gradient(45deg, #f8f9fa, #e9ecef)' }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <h5 className="card-title mb-1 fw-bold text-primary">
                                        <i className="fa fa-lightbulb me-2"></i>
                                        {/* {keyInfo.title} */}
                                    </h5>
                                    <small className="text-muted">
                                        <i className="fa fa-clock me-1"></i>
                                        Generated: {formatTimestamp(searchHistory[0]?.timestamp || new Date().toISOString())}
                                    </small>
                                </div>
                                <div className="d-flex gap-2">
                                    <span className="badge bg-primary rounded-pill">
                                        <i className="fa fa-tokens me-1"></i>
                                        {tokenUsage?.total_tokens || 0} tokens
                                    </span>
                                    <span className="badge bg-success rounded-pill">
                                        <i className="fa fa-check-circle me-1"></i>
                                        Complete
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            {/* Summary Section */}
                            {/* <div className="mb-4">
                                <h6 className="fw-bold mb-2">
                                    <i className="fa fa-file-text me-2 text-primary"></i>
                                    Summary
                                </h6>
                                <p className="card-text text-justify">{result ? result : ""}</p>
                            </div> */}



                            {/* Key Features */}
                            {/* {keyInfo.features.length > 0 && (
                                <div className="mb-4">
                                    <h6 className="fw-bold mb-2">
                                        <i className="fa fa-star me-2 text-warning"></i>
                                        Key Features
                                    </h6>
                                    <div className="row">
                                        {keyInfo.features.map((feature, index) => (
                                            <div key={index} className="col-md-6 mb-2">
                                                <div className="d-flex align-items-start">
                                                    <i className="fa fa-check-circle text-success me-2 mt-1 flex-shrink-0"></i>
                                                    <span className="small">{feature}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )} */}

                            {/* Full Response in Collapsible Section */}
                            {
                                tireListings && tireListings.length > 0 && (
                                    <div className="mt-4">
                                        
                                        <div className="" id="">
                                            <div className="card card-body bg-light">
                                                <pre style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem', marginBottom: 0 }}>
                                                    {(tireListings)}
                                                </pre>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }



                            {/* Action Buttons */}
                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-outline-primary w-100 mb-2"
                                        onClick={() => navigator.clipboard.writeText(result)}
                                    >
                                        <i className="fa fa-copy me-2"></i>
                                        Copy Response
                                    </button>
                                </div>
                                <div className="col-md-6">
                                    <button
                                        className="btn btn-outline-success w-100 mb-2"
                                        onClick={() => {
                                            const blob = new Blob([result], { type: 'text/plain' });
                                            const url = URL.createObjectURL(blob);
                                            const a = document.createElement('a');
                                            a.href = url;
                                            a.download = `gpt-search-result-${Date.now()}.txt`;
                                            a.click();
                                        }}
                                    >
                                        <i className="fa fa-download me-2"></i>
                                        Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            {/* Empty State */}
            {!loading && !result && !error && (
                <div className="card shadow-sm text-center py-5 animate__animated animate__fadeIn">
                    <div className="card-body">
                        <i className="fa fa-brain fa-5x text-muted mb-3" style={{ opacity: 0.5 }}></i>
                        {/* <h4 className="card-title text-muted">Ready to Search</h4> */}
                        {/* <p className="card-text text-muted">
              Enter your prompt above to get detailed information with comprehensive token tracking
            </p> */}
                        {/* <small className="text-muted">
              <i className="fa fa-lightbulb me-1"></i>
              Try searching for product specifications, technical details, or ask any question
            </small> */}
                    </div>
                </div>
            )}

            {/* Custom Styles */}
            <style jsx>{`
        .cursor-pointer {
          cursor: pointer;
        }
        .animate__fadeInUp {
          animation-duration: 0.6s;
        }
        .animate__fadeInDown {
          animation-duration: 0.8s;
        }
        .animate__fadeIn {
          animation-duration: 0.5s;
        }
        .card {
          transition: all 0.3s ease;
        }
        .card:hover {
          transform: translateY(-2px);
        }
        .badge:hover {
          transform: scale(1.05);
          transition: transform 0.2s ease;
        }
        .btn {
          transition: all 0.3s ease;
        }
        .btn:hover {
          transform: translateY(-1px);
        }
        .progress-bar {
          transition: width 0.6s ease;
        }
        .text-justify {
          text-align: justify;
        }
        pre {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
      `}</style>

            {/* Bootstrap JS for collapsible */}
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>
        </div>
    );
};

export default GPTAgentFrontend;